import { defineMessages } from 'utils/intl';

export default defineMessages({
  from: 'od {time}',
  to: 'do {time}',
});
